/** Ortak arayüz metinleri — baş harfler büyük, Türkçe karakterler doğru */

export const UI_LOADING = "Yükleniyor…";

export const UI_CANCEL = "İptal";
export const UI_SAVE = "Kaydet";
export const UI_UPDATE = "Güncelle";
export const UI_CREATE = "Oluştur";
export const UI_EDIT = "Düzenle";
export const UI_DELETE = "Sil";
export const UI_CLOSE = "Kapat";
export const UI_REFRESH = "Yenile";
export const UI_PREVIOUS = "Önceki";
export const UI_NEXT = "Sonraki";
export const UI_ALL = "Tüm";
export const UI_SEARCH = "Ara";
export const UI_UPLOAD = "Yükle";
export const UI_RESET = "Sıfırla";
export const UI_BACK = "Geri";

export const UI_INSTRUCTOR = "Eğitmen";
export const UI_STUDENT = "Kursiyer";
export const UI_VEHICLE = "Araç";
export const UI_BRANCH = "Şube";
export const UI_USER = "Kullanıcı";
export const UI_DATE = "Tarih";
export const UI_TIME = "Saat";
export const UI_STATUS = "Durum";
export const UI_NOTE = "Not";
export const UI_ACTION = "İşlem";
export const UI_DETAIL = "Detay";
